import './Loading.less'
import Loading from './Loading'
export default Loading
